import CheckboxWithVisual from './CheckboxWithVisual';

export default CheckboxWithVisual;
